module.exports = __webpack_public_path__ + "img/bulma-light.52eb1b1c.png";